import { jsx as _jsx } from "react/jsx-runtime";
import { DEPRECATED_TextInput } from "../../../components/DEPRECATED_TextInput";
import { FormField } from "../../../components/Form";
import { useTranslations } from "../../../providers/useTranslations";
const DISTRICT_NAME = "districtName";
export const DistrictField = ({ fieldName: getFieldName, required = true }) => {
    const { __ } = useTranslations();
    const fieldName = getFieldName(DISTRICT_NAME);
    return (_jsx(FormField, { dataTestId: fieldName, label: __("address_fields.district"), name: fieldName, render: ({ field }) => {
            return (_jsx(DEPRECATED_TextInput, { ...field, placeholder: __("address_fields.district_placeholder"), dataTestId: `${fieldName}-input` }));
        }, validation: { required: required ? __("form_validation.field_required") : false } }));
};
//# sourceMappingURL=DistrictField.js.map